import { render, staticRenderFns } from "./SelectBankAccount.vue?vue&type=template&id=0ecfd948"
import script from "./SelectBankAccount.vue?vue&type=script&lang=js"
export * from "./SelectBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports